module.exports = __webpack_public_path__ + "static/media/border_value_active_icon.d420e7c7.svg";